import React from 'react';

import {PredictionPlaceholderInsight} from "./prediction.placeholder.insight";
import {PredictionPlaceholderVoting} from "./prediction.placeholder.voting";
import {PredictionPlaceholderTitle} from "./prediction.placeholder.title";

export const PredictionPlaceholder = (props) => {
  return (
    <div className={'prediction-placeholder-container'}>
      <PredictionPlaceholderTitle/>
      <PredictionPlaceholderInsight/>
      <PredictionPlaceholderVoting/>
    </div>
  )
}
